import React, { useEffect } from "react";
import LoginForm from "../../components/LoginForm";
import { changeDocumentTitle } from "../../utils/title";

const Login = ({ onLogin }) => {
  useEffect(() => {
    changeDocumentTitle("Login");
  }, [])
  return (

    <div className=" flex items-center gap-0 ">
      {/* Left section with heading, paragraph, and image */}
      <div
        style={{
          flex: 1,
          border: "12px #ccc",
          padding: "15px",
          paddingTop: "2px",
          display: "flex",
          borderTopLeftRadius: '24px',
          borderBottomLeftRadius: '24px',
          flexDirection: "column",
          justifyContent: "center",
          paddingLeft: "45px",
          width: "50%",
          background: `linear-gradient(140.09deg, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.95) 100%)`,
          // backgroundSize: "cover",
          // backgroundPosition: "center",
          // overflow: "hidden",
          height: "550px",
        }}
      >
        <p className="text-white  opacity-65">START FOR FREE</p>
        <h1
          style={{
            fontSize: "38px",
            fontWeight: "bold",
            marginBottom: "10px",
            marginLeft: "0px",
            color: "white",
          }}
        >
          Welcome  back to{" "}
          <div style={{ fontSize: "38px" }}>

            <span
              style={{
                fontSize: "38px",
                color: "#A11C29"
              }}
            >
              Ctrade
            </span>
            {" "}
            <span style={{
              fontSize: "38px",
              color: "#A11C29"
            }}>
              USA
            </span>
          </div>

        </h1>
        <p
          style={{
            fontSize: "16px",
            lineHeight: "1.5",
            marginBottom: "15px",
            color: "white",
            width: "70%",
          }}
          className="opacity-65"
        >
          Manage your operations with a few clicks.
          Get real time data, track tasks, and stay
          updated.
        </p>
        <p
          style={{
            fontSize: "16px",
            lineHeight: "1.5",
            marginBottom: "15px",
            color: "white",
          }}
        >

        </p>
        <ul className="text-white text-sm opacity-65 space-y-3">
          {[
            "Real time vehicle tracking",
            "Smart invoice and balance control",
            "Easy loading and yard management",
            "Your smarter journey begins here",
          ].map((item, index) => (
            <li key={index} className="flex items-start gap-4">
              <span className="mt-2 h-2 w-2 rounded-full bg-[#A11C29] flex-shrink-0"></span>
              <span className="leading-relaxed">{item}</span>
            </li>
          ))}
        </ul>

      </div>
      {/* Right section with Login Form */}
      <div
        style={{
          height: "550px",
          backgroundColor: "white",
          width: "48%",
          display: "flex",
          alignItems: "center",
          paddingLeft: 18,
          borderTopRightRadius: '24px',
          borderBottomRightRadius: '24px',
        }}
      >
        <LoginForm onLogin={onLogin} />
      </div>
    </div>

  );
};

export default Login;
